export default "__VITE_ASSET__Bw$QDLtb__"